<template>
  <div class="intent-section px-7">
    <div class="hb-font-header-2-medium mt-n1 mb-4">Move-Out Statement</div>

    <hb-card
      v-if="(moveOutCalc.lease || (currentRefund && currentRefund.credit)) && !contact?.national_account_id"
      border
      no-title
      :box-shadow="(leaseInfo && leaseInfo.promotion) || (currentRefund && currentRefund.credit && currentRefund.credit > 0) ? true : false"
    >
      <div style="padding: 10px 16px">
        <div class="pb-1">
          <span class="hb-font-body-medium"> Move-In Date:</span> <span class="hb-font-body"> {{ moveOutCalc.lease?.start_date | formatDate  }} </span>
        </div>
        <div class="pb-1" v-if="moveOutCalc.lease?.promotion || moveOutCalc.lease?.Promotions.length">
          <span class="hb-font-body-medium"> Move-In Promotion:</span> <span class="hb-font-body"> {{moveOutCalc.lease?.promotion || 'No Move In Promotion'}} </span>
        </div>
        <div class="pb-1">
          <span class="hb-font-body-medium"> Move-Out Date: </span> <span class="hb-font-body"> {{ this.move_out_date |  formatDate }} </span>
        </div>
        <div class="pb-1">
          <span class="hb-font-body-medium"> Enrolled in AutoPay: </span> <span class="hb-font-body"> {{ leaseInfo?.has_autopay ? 'Yes' : 'No' }} </span>
        </div>
      </div>
    </hb-card>

    <!-- <buttons/> -->
    <v-col class="px-0 pt-0">
      <!-- Move-Out Reasons, Sold At Auction -->
      <v-expansion-panels multiple v-model="moveOutPanels">
         <hb-expansion-panel key="move-out-reasons" expand-icon-off disabled>
          <template v-slot:title>
            Move-Out Reasons
          </template>
          <template v-slot:content>
              <v-row class="mx-6">
                <v-col cols="6" class="pt-3 pb-5 pl-0">
                  <v-select
                  :items = "move_out_reasons"
                  label="Select Reason for Move Out"
                  v-model = "selectedMoveOutReason"
                  :error-messages="moveOutReasonsErrors.selectedMoveOutReason"
                  ></v-select>
                </v-col>
            </v-row>
          </template>
        </hb-expansion-panel>
        <hb-expansion-panel success key="auction" v-if="lease.auction_status == 'move_out'" title-icon="mdi-gavel">
          <template v-slot:title>
            Sold at Auction
          </template>
          <template v-slot:content>
            <auction-sold :auctionLease="lease"></auction-sold>
          </template>
        </hb-expansion-panel>

        <!-- <hb-expansion-panel error key="incomplete-prep" v-if="!readyToMove && products && products.length">
          <template v-slot:title>
            Incomplete Prep For Rental
          </template>
          <template v-slot:content>
            <div class="pb-3 px-6">
              <incomplete-prep
                :lease_id="lease_id"
                :property_id="property_id"
                :lease="lease"
                :contact="contact"
                @openBalance="setOpenBalance"
              />
            </div>
          </template>
        </hb-expansion-panel> -->

        <!-- <hb-expansion-panel error key="open-balance" v-if="(lease.auction_status !== 'move_out') && totalDue && totalDue > 0" v-show="!contact?.national_account_id">
          <template v-slot:title>
            <span class="mt-1">
              Open Balance:
            </span>
            <span class="ml-1 hb-font-body font-weight-regular">{{totalDue && totalDue > 0 ? '$' + totalDue : '' }}</span>
          </template>
          <template v-slot:content>
            <div class="pb-3 px-6">
              <Payments
                  :lease_id="lease_id"
                  :unit_id="unit_id"
                  :property_id="property_id"
                  :contactId="contact_id"
                  :payment_amount="totalDue"
                  :move_out_date="move_out_date"
                  @openBalance="setOpenBalance"
              />
            </div>
          </template>
        </hb-expansion-panel> -->

        <!-- <hb-expansion-panel caution key="security-deposit-refund" v-if="securityDeposit && securityDeposit > 0">
          <template v-slot:title>
            <span class="mt-1">
              Security Deposit:
            </span>
            <span class="ml-1 hb-font-body font-weight-regular">{{ securityDeposit | formatMoney }}</span>
          </template>
          <template v-slot:content>
            <div class="pb-3 px-6">
              <security-deposit-refund
                @fetchSecurityDeposit="fetchSecurityDeposit"
                :lease_id="lease_id"
                :security_deposit="securityDeposit"
                @securityRefunded="securityRefunded"
              />
            </div>
          </template>
        </hb-expansion-panel>
        <hb-expansion-panel error key="refund-request" :readonly="!isSecurityRefunded && securityDeposit && securityDeposit > 0 ? true : false" :expand-icon-off="!isSecurityRefunded && securityDeposit && securityDeposit > 0 ? true : false" v-if="amt_to_refund > 0 && !contact?.national_account_id">
          <template v-slot:title>
            <span class="mt-1">
              Refund Request:
            </span>
            <span class="ml-1 hb-font-body font-weight-regular">{{ amt_to_refund | formatMoney }}</span>
          </template>
          <template v-slot:actions>
            <v-tooltip bottom v-if="!isSecurityRefunded && securityDeposit && securityDeposit > 0">
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on"><hb-icon small color="#00000087" mdi-code="mdi-alert-circle"></hb-icon></span>
              </template>
              <span>Please process the refund of the security deposit first.</span>
            </v-tooltip>
          </template>
          <template v-slot:content>
            <div class="pb-3 px-6">
              <refund-request
                :account_balance="account_balance"
                :amt_to_refund="amt_to_refund"
                :overpayments="overpayments"
                :move_out_date="move_out_date"
                @fetchPayments="fetchOverPayments"
                :lease_id="lease_id"
                :current_refund="amt_to_refund"
                :contact_id="contact_id"
              />
            </div>
          </template>
        </hb-expansion-panel> -->
      </v-expansion-panels>
      <!-- Due Invoice, Add new charges -->
      <v-expansion-panels v-model="panels" v-if="!contact?.national_account_id">
          <hb-expansion-panel key="charges">
            <template v-slot:title>
              Charges
            </template>
            <template v-slot:actions>
              <span class="hb-font-body-medium">
                {{ moveOutCalc?.totalDue | formatMoney }}
              </span>
            </template>
            <template v-slot:content>
              <invoices-view 
              :property_id="property_id"
              :lease_id="lease_id"
              :move_out_date= "move_out_date"
              :moveOutCalc="moveOutCalc"
              />
            </template>
      </hb-expansion-panel>
      </v-expansion-panels>
      <!-- Refunds, Direct Refund Details -->
      <v-expansion-panels multiple v-model="refundPanels">
        <hb-expansion-panel error v-if="moveOutCalc?.total_to_refund > 0 && !contact?.national_account_id" key="refund-view" right-cols="6" left-cols="6" no-top-margin>
          <template v-slot:title>
            <div class="d-flex align-center justify-space-between w-100 refund-checkbox-container">
              <div class="d-flex align-center">
                <span class="mr-2" :class="{ 'text--disabled': !enableRefund }">
                  Refunds
                </span>
              </div>
            </div>
          </template>
          <template v-slot:actions>
            <hb-switch 
                v-model="enableRefund" 
                class="ml-3" 
                @change="updateSkipRefund" 
                right
                hide-details
              />
              <span class="hb-font-body-medium">
                {{ moveOutCalc.total_to_refund | formatMoney }}
              </span>
          </template>
          <template v-slot:content>
            <div class="pb-3 px-6">
              <refund-view
                :account_balance="account_balance"
                :amt_to_refund="moveOutCalc.total_to_refund"
                :overpayments="overpayments"
                :moveOutCalc="moveOutCalc"
                :move_out_date="move_out_date"
                :lease_id="lease_id"
                :current_refund="moveOutCalc.message.refund_amount"
                :contact_id="contact_id"
                @security-deposit-updated="updateComponent"
                :class="{ 'opacity-60': !enableRefund }"
              />
            </div>
<!--            <div class="pb-3 px-6">-->
<!--              <hb-radio-group v-model="refundType" v-if="(isAUS || isNZ) && moveOutCalc.message.refund_amount > 0">-->
<!--                <hb-radio value="now" label="Refund Now"/>-->
<!--                <hb-radio value="later" label="Refund Later"/>-->
<!--              </hb-radio-group>-->
<!--            </div>-->
          </template>
        </hb-expansion-panel>
        <hb-expansion-panel v-if="refundType == 'later' && this.moveOutCalc.message?.refund_amount > 0" key="refund-later" hide-actions-when-closed>
          <template v-slot:title>
            Direct Refund Details
          </template>
          <template v-slot:content>
            <v-col cols="6" class="pb-3 px-6">
              <v-text-field
                cols="6" 
                class="my-n1 pr-2"
                v-model="reversal.directrefund_account_name"
                v-validate.disable="'required|max:32'"
                data-vv-as="Account Name"
                data-vv-scope="reversal"
                :error="errors.has('reversal.directrefund_account_name')"
                label="Account Name*"
                id="directrefund_account_name"
                name="directrefund_account_name"
                >
              </v-text-field>
              <v-text-field
                cols="6" 
                class="my-n1 pr-2"
                v-if="isAUS"
                v-model="reversal.directrefund_bsb_number"
                v-validate.disable="'required|numeric|length:6'"
                maxlength="6"
                data-vv-as="BSB Number"
                data-vv-scope="reversal"
                :error="errors.has('reversal.directrefund_bsb_number')"
                label="BSB Number*"
                id="directrefund_bsb_number"
                name="directrefund_bsb_number"
                >
              </v-text-field>
            
              <v-text-field
                cols="6" 
                class="my-n1 pr-2"
                v-model="reversal.directrefund_account_number"
                v-validate="{ required: true, numeric: true, customAccountNumberValidation: true }"
                data-vv-as="Account Number"
                data-vv-scope="reversal"
                :error="errors.has('reversal.directrefund_account_number')"
                label="Account Number*"
                id="directrefund_account_number"
                name="directrefund_account_number"
              >
              </v-text-field>
            </v-col>
          </template>
        </hb-expansion-panel>
      </v-expansion-panels>
      <!-- Take Payment, Skip Payment, Write Off Payment -->
      <div class="mt-2 pl-1 mb-n3">
          <hb-radio-group row v-model="paymentOption" v-if="!contact?.national_account_id && moveOutCalc.message?.amount_due > 0">
                <hb-radio value="takePayment" label="Take Payment" class="mr-2"/>
                <hb-radio value="skipPayment" label="Skip Payment" class="mr-2"/>
                <hb-radio value="writeOff" label="Write Off"/>
          </hb-radio-group>
      </div>
      <!-- Take Payment -->
      <v-expansion-panels multiple v-model="paymentPanels">
        <hb-expansion-panel v-if="moveOutCalc.message?.amount_due > 0 && !contact?.national_account_id && paymentOption==='takePayment'" key="payment" :value="true">
              <template v-slot:title>
                Total Payment
              </template>          
              <template v-slot:actions>
                <div class="hb-font-body-medium align-right">
                  {{ moveOutCalc.message.amount_due | formatMoney }}
                </div>
              </template>
              <template v-slot:content>
                <div class="py-1 px-0">
                  <payment-view 
                  :key="componentKey"
                  :property_id="property_id"
                  :payment_amount="moveOutCalc.message.amount_due"
                  :lease_id="lease_id"
                  :contactId="contact_id"
                  :moveOutCalc="moveOutCalc"
                  ref="paymentView"
                  />
                </div>
              </template>
        </hb-expansion-panel>
      </v-expansion-panels>
      <!-- Move Out Notes -->
      <v-expansion-panels v-model="moveOutNotes">
        <hb-expansion-panel key="move-out-notes" hide-actions-when-closed>
          <template v-slot:title>
            Move-Out Notes
          </template>
          <template v-slot:actions>
            <hb-btn small color="secondary" @click.native.stop="showNoteModal =! showNoteModal" class="pr-2">Add Note</hb-btn>
          </template>
          <template v-slot:content>
            <notes :show-note-modal="showNoteModal" :contact_id="contact_id" :unit_number="spaceNumber" :lease_id="lease_id" @close="closeNotesModal" />
          </template>
        </hb-expansion-panel>
      </v-expansion-panels>
    </v-col>

    <div class="new-tenant-walkthrough-footer">
      <v-row>
        <v-col class="pt-4">
          <help-juice />
        </v-col>
        <v-col cols="9" class="d-flex align-center justify-end pr-sm-7">
          <hb-link class="mr-2" @click="$emit('close')">Cancel</hb-link>
          <hb-btn v-if="inCall && ivrPaymentType === 'card' &&  IvrPaymentEnable && ivrPaymentMethod == 'new' " color="primary" @click="completeSession()" :disabled="!enableIvrProcessPayment" :loading="ivrPaymentButtonLoading">Confirm Move Out {{ivrTimeout}}</hb-btn>  
          <hb-btn v-else class="mr-2"  color="primary" @click="contact?.national_account_id ? closeLease() : processMoveOut()" :loading="closeLeaseInProgress" :disabled="moveOutButtonDisabled">
            Move Out
          </hb-btn>
        </v-col>
      </v-row>
    </div>

    <hb-modal v-model="confirmationModal" v-if="confirmationModal" size="medium" title="Move out confirmation" confirmation>
            <template v-slot:content>
                <div class="pa-6">
                    <!-- Take Payment Scenario -->
                    <div v-if="moveOutCalc.message?.amount_due > 0 && paymentOption === 'takePayment'">
                        <p class="hb-font-body">
                          The tenant owes <strong>{{ moveOutCalc.message.amount_due | formatMoney }}</strong> for past charges which will be processed.
                        </p>
                        <p class="hb-font-body">
                          After this, the tenant will be moved out, and the lease for {{ spaceNumber ? `Space #${spaceNumber}` : 'this unit' }} will be closed.
                        </p>
                    </div>

                    <!-- Skip Payment Scenario -->
                    <div v-else-if="moveOutCalc.message?.amount_due > 0 && paymentOption === 'skipPayment'">
                        <p class="hb-font-body">
                          The tenant owes <strong>{{ moveOutCalc.message.amount_due | formatMoney }}</strong> for past charges, but this amount will be skipped.
                        </p>
                        <p class="hb-font-body">
                          The tenant will be moved out, and the lease for {{ spaceNumber ? `Space #${spaceNumber}` : 'this unit' }} will be closed.
                        </p>
                    </div>

                    <!-- Write-off Scenario -->
                    <div v-else-if="moveOutCalc.message?.amount_due > 0 && paymentOption === 'writeOff'">
                        <p class="hb-font-body">
                          The tenant owes <strong>{{ moveOutCalc.message.amount_due | formatMoney }}</strong> for past charges, which will be written off as a loss.
                        </p>
                        <p class="hb-font-body">
                          The tenant will be moved out, and the lease for {{ spaceNumber ? `Space #${spaceNumber}` : 'this unit' }} will be closed.
                        </p>
                        
                        <!-- Write-off Reason Input -->
                        <div class="mt-4">
                            <hb-form :label="'Reason for write-off'" required>
                                <v-col cols="12" class="px-0">
                                    <div class="write-off-reason">
                                        <hb-textarea
                                            :disabled="isAuctionWriteOff"
                                            v-model="writeOffReason"            
                                            v-validate.disable="'required|max:1000'"
                                            id="writeOffReason"
                                            name="writeOffReason"
                                            data-vv-scope="reversal"
                                            data-vv-as="Reason for Write-off"
                                            :error="errors.has('writeOffReason')"
                                            :placeholder="'Enter Reason for write-off'"
                                        ></hb-textarea>
                                    </div>
                                </v-col>
                            </hb-form>
                        </div>
                    </div>

                    <!-- Refund Scenario -->
                    <div v-else-if="moveOutCalc.total_to_refund > 0 || moveOutCalc.message?.refund_amount > 0">
                        <div v-if="skipRefund">
                            <p class="hb-font-body">
                              A refund of <strong>{{ (moveOutCalc.total_to_refund || moveOutCalc.message.refund_amount) | formatMoney }}</strong> is due to the tenant, but <strong>refund processing has been disabled</strong> and will be skipped.
                            </p>
                            <p class="hb-font-body">
                              The tenant will be moved out, and the lease for {{ spaceNumber ? `Space #${spaceNumber}` : 'this unit' }} will be closed.
                            </p>
                        </div>
                        <div v-else>
                            <p class="hb-font-body">
                              A refund of  <strong>{{ (moveOutCalc.total_to_refund || moveOutCalc.message.refund_amount) | formatMoney }}</strong> is due to the tenant and will be processed.
                            </p>
                            <p class="hb-font-body" v-if="moveOutCalc?.securityDepositToRefund > 0 ">
                              The refund includes the 
                              <strong v-if="moveOutCalc?.securityDepositToRefund > ((moveOutCalc.total_to_refund - (moveOutCalc.totalDue || 0)) || moveOutCalc.message.refund_amount)">{{ ((moveOutCalc.total_to_refund - (moveOutCalc.totalDue || 0)) || moveOutCalc.message.refund_amount) | formatMoney }}</strong>
                              <strong v-else >{{ moveOutCalc?.securityDepositToRefund | formatMoney }}</strong>

                               security deposit, which must be refunded using an offline payment method such as cash or cheque.
                            </p>
                            <p class="hb-font-body">
                              The tenant will be moved out, and the lease for {{ spaceNumber ? `Space #${spaceNumber}` : 'this unit' }} will be closed.
                            </p>
                        </div>
                    </div>

                    <!-- Generic Fallback -->
                    <div v-else>
                        <p class="hb-font-body">
                          The tenant will be moved out, and the lease for {{ spaceNumber ? `Space #${spaceNumber}` : 'this unit' }} will be closed.
                        </p>
                    </div>
                </div>
            </template>
            <template v-slot:actions>
                <hb-btn
                    color="primary"
                    @click="confirmMoveOut"
                >
                    Confirm
                </hb-btn>
            </template>
        </hb-modal>

  </div>
</template>
<script type="text/babel">
  import MaintenanceScheduled from "./MaintenanceScheduled.vue";
  import AuctionSold from "./AuctionSold.vue";
  import IncompletePrep from "./IncompletePrep.vue";
  import RefundRequest from "./RefundRequest.vue";
  import RefundView from "./RefundView.vue";
  import SecurityDepositRefund from "./SecurityDepositRefund.vue";
  import Buttons from "./Buttons.vue";
  import Notes from "./Notes.vue";
  import ActivityLogs from "./ActivityLogs.vue";
  import Payments from "./Payments.vue";
  import InvoicesView from "./InvoicesView.vue";
  import PaymentView from "./PaymentView.vue";
  import api from '../../../../assets/api.js';
  import moment from 'moment';
  import { EventBus } from '../../../../EventBus.js';
  import { mapGetters, mapActions, mapMutations } from 'vuex';
  import { notificationMixin } from  '../../../../mixins/notificationMixin.js';

export default {
  name: "MoveOutStatementIndex",
  components: {
    MaintenanceScheduled,
    AuctionSold,
    IncompletePrep,
    RefundRequest,
    RefundView,
    SecurityDepositRefund,
    Buttons,
    InvoicesView,
    Notes,
    ActivityLogs,
    Payments,
    PaymentView
  },
  mixins: [ notificationMixin ],
  data: () => ({
    amt_to_refund: 0,
    amount: 0,
    totalActivities: 0,
    account_balance: 0,
    overpayments: 0,
    securityDeposit: 0,
    refundInvoices:[],
    showNoteModal: false,
    leaseInfo: null,
    leaseClosed: false,
    move_in_ready: 1,
    products: [],
    leases: [],
    panels: [ 2 ],
    moveOutPanels: [0],
    refundPanels:[0,1],
    paymentPanels:[0],
    isLoading: false,
    finalizeInProgress: false,
    closeLeaseInProgress: false,
    isSecurityRefunded: false,
    move_out_reasons: [],
    selectedMoveOutReason: '',
    refundType: 'now',
    reversal: {},
    isAUS: false,
    isNZ: false,
    confirmationModal: false,
    confirmationResolve: null,
    properties: null,
    paymentOption: 'takePayment',
    write_off : false,
    writeOffReason: '',
    componentKey: 0,
    moveOutReasonsErrors: {
      selectedMoveOutReason: ''
    },
    enableRefund: true,
    skipRefund: false
  }),
  props: ['close', 'contact_id', 'lease', 'contact', 'property_id','lease_id', 'unit_id', "move_out_date", "ready_to_move_in"],
  async created() {
    this.isLoading = true
    await this.setupValidation();
    this.$emit('showLeaseSummary');
    this.fetchOverPayments();
    await this.fetchSecurityDeposit();
    if(!this.contact?.national_account_id){
    await this.calculateMoveOutDate();
    }
    this.getLeaseInfo();
    this.getFees();
    await this.setContactInvoices();
    await this.getMoveOutReasons();
    if(this.lease.end_date && this.lease.end_date >= moment().startOf('day').format('YYYY-MM-DD')){
      this.leaseClosed = true;
    }
    EventBus.$on("get_data_for_move_out_charm_ivr",this.getMoveOutData)
    this.updateIvrPaymentEnable(true)
    this.isLoading = false
  },
  // filters: {
  //   formatDate(value) {
  //     if (!value) return null;
  //     return moment(value).format("MMMM DD, YYYY");
  //   }
  // },
  destroyed(){
      this.updateIvrPaymentEnable(false)
      EventBus.$off("get_data_for_move_out_charm_ivr",this.getMoveOutData)
  },
  computed: {
      inCall() {
        return this.notification.status === 'active';
      },
      ivrTimeout(){
          return this.ivrTimer
      },
      ...mapGetters({
        ivrTimer:'charmCallStore/ivrTimer',
        ivrPaymentButtonLoading:'charmCallStore/ivrPaymentButtonLoading',
        paymentConnectorResponse:'charmCallStore/paymentConnectorResponse',
        enableIvrProcessPayment:'charmCallStore/enableIvrProcessPayment',
        ivrPaymentMethod:'charmCallStore/ivrPaymentMethod',
        IvrPaymentEnable:'charmCallStore/IvrPaymentEnable',
        ivrPaymentType:'charmCallStore/ivrPaymentType',
        notification: "charmCallStore/notification",
        charmNotification: "charmNotificationStore/charmNotification",
        payment: 'paymentsStore/getPayment',
        payment_information: 'paymentsStore/getPaymentInformation',
        payment_method: 'paymentsStore/getPaymentMethod',
        moveOutCalc: 'paymentsStore/getMoveOutCalc',
        additionalCharges: 'paymentsStore/getAdditionalCharges',
        securityDepositForRefund: 'paymentsStore/getSecurityDeposit'
      }),

      moveOutButtonDisabled() {
        return this.closeLeaseDisabled || 
              this.leaseClosed || 
              this.isLoading || 
              this.closeLeaseInProgress || 
              this.finalizeInProgress;
      },
    currentRefund(){
        return this.refundInvoices.find(x => x.credit > 0);
    },
    spaceNumber(){
      return this.leases[0]?.Unit?.number
    },
    readyToMove() {
      return this.$props.ready_to_move_in;
    },
    moveSpaceToInventory() {
      let current_date = moment().startOf('day').format('YYYY-MM-DD')
      if(!this.$props.lease.end_date || this.$props.lease.end_date > current_date || this.$props.lease?.Unit?.status == 1) {
        return true
      }
      else {
        return false;
      }
    },
    closeLeaseDisabled() {
      return this.$props.lease.move_out ? true : false;
    },
    totalDue(){
      // lease_total is Open Balance : Sum of balances of all unpaid invoices of a lease having due date <= move_out_date
      let lease_total = this.leases.reduce((total, l) => total + (l.OpenInvoices.filter(oi => oi.due <= this.move_out_date).reduce((total_balance, oi) => total_balance + oi.balance, 0)), 0);
      let new_charges = this.leases.reduce((a,b) => a + (b.Charges && b.Charges.balance ? b.Charges.balance : 0), 0);
      return Math.round((lease_total + new_charges) * 1e2) / 1e2;
    },
  },
  watch: {
    async paymentConnectorResponse(responseData){
      try {
          let readyToMove = this.readyToMove;
          console.log('paymentConnectorResponse 506:', responseData);
              if(!responseData) return
              if(responseData.status == 200){
                let response = responseData;
                console.log('response:', response);
                this.setPaymentProcessDisabled(false)
                if (readyToMove) {
                  await this.moveSpaceBackToInventory();
                  if(response){
                    this.leaseClosed = true;
                    this.closeLeaseConfirmation = false;
                    EventBus.$emit('lease_edited');
                    this.$emit('fetchLeaseData');
                    EventBus.$emit('contact_updated', this.contact_id);
                    EventBus.$emit('contact_updated_transfer');
                    EventBus.$emit('reservation_made');
                  }
                }
                this.refreshContactUnits();
                this.$emit('close');

            this.refreshContactUnits();
            this.$emit('close');

            await this.resetPropertiesInfo();
            await this.fetchPropertyGroups({hardRefresh: true});
          } 
      }catch (e) {
        this.showMessageNotification({ type: 'error', description: e });
      } finally {
        this.setPaymentProcessDisabled(false)
        this.closeLeaseInProgress = false;
      }
    },
    moveOutCalc: function (oldVal, newVal){
      if(oldVal !== newVal){
        this.componentKey += 1;
        if (this.moveOutCalc.message?.amount_due > 0 && !this.contact?.national_account_id && this.paymentOption === 'takePayment') {
          let PAYMENT_PANEL = 2
          if (this.moveOutCalc.total_to_refund > 0) {
            PAYMENT_PANEL = 3
          }
            this.moveOutPanels.push(PAYMENT_PANEL);
            this.paymentPanels.push(0)
        }
        if(this.moveOutCalc.message?.refund_amount > 0 && !this.contact?.national_account_id){
          // Make sure the refund panel is in the moveOutPanels array
            this.refundPanels = [0, 1];
            this.paymentOption = 'takePayment';
        }
        this.setPaymentInformationObject({ paymentInformation: { ...this.payment_information, ...{ amountTendered: Number(this.moveOutCalc?.message?.amount_due).toFixed(2), totalNewPaymentPaying: Number(this.moveOutCalc?.message?.amount_due).toFixed(2), totalNewPaymentDue: Number(this.moveOutCalc?.message?.amount_due).toFixed(2) } } });       
      }
    },
    async refundType(newVal){
      if(newVal == 'later'){
        await this.isAUSOrNZ();
        console.log("Aus: ",this.isAUS)
        console.log("NZ: ",this.isNZ)
      }
    },
    async paymentOption(newVal){
      if(newVal == 'takePayment'){
        this.write_off = false;
        this.payment_amount = Number(this.totalDue).toFixed(2);
        if (this.moveOutCalc.message?.amount_due > 0 && !this.contact?.national_account_id) {
          this.paymentPanels = [0];
        }
      } else if(newVal == 'writeOff'){
        // Write-off modal trigger removed - will be handled in unified confirmation modal
      }else{
        this.write_off = false;
      }
    },
    
    confirmationModal(newVal) {
      // Handle modal close without confirmation (e.g., clicking outside, pressing escape)
      if (newVal === false && this.confirmationResolve) {
        this.confirmationResolve(false);
        this.confirmationResolve = null;
      }
    }
  },
  methods: {
    async completeSession(){
      EventBus.$emit('complete-ivr-payment-session');
    },
    updateSkipRefund() {
      this.skipRefund = !this.enableRefund;
    },
    ...mapMutations({
      updateIvrPaymentEnable:'charmCallStore/updateIvrPaymentEnable',
      resetContact: 'onBoardingStore/resetContact',
      setPaymentObject: 'paymentsStore/setPaymentObject',
      setPaymentInformationObject: 'paymentsStore/setPaymentInformationObject',
      setMoveOutCalc: 'paymentsStore/setMoveOutCalc',
    }),
    ...mapActions({
      getTransformedPaymentObject: 'paymentsStore/getTransformedPaymentObject',
      resetPropertiesInfo: 'propertiesStore/resetPropertiesInfo',
      fetchPropertyGroups: 'propertiesStore/fetchPropertyGroups',
      setPaymentProcessDisabled: 'paymentsStore/setPaymentProcessDisabled',
    }),
    writeOff(){
        var invoice_ids = [];

        for(var i = 0; i < this.leases.length; i++) {
            let lease = this.leases[i]
            let open_invoices = lease.OpenInvoices.filter(oi => oi.due <= this.move_out_date);
            for(var j = 0; j < open_invoices.length; j++) {
                var obj = {};
                obj['invoice_id'] = open_invoices[j].id;
                invoice_ids.push(obj);
            }
        }

        var data = {
            amount: Number(this.payment_amount).toFixed(2),
            notes: '',
            invoices: invoice_ids,
            contact_id: this.contact_id,
            source: 'move_out'	
        }
        
        // return api.post(this, api.LEASES + this.lease_id + '/invoices/write-off', data).then(r => {
            // this.$emit('openBalance');
            if(!this.writeOffReason || this.writeOffReason == ''){
                this.showMessageNotification({ description: 'A reason for the write-off is required. Please complete the necessary fields and try again'});
                return;
            }
            this.write_off = true;
            this.componentKey += 1;
        // }).catch(err => {
        //     this.showMessageNotification({ description: err});
        // });
    },
    async isDirectRefundValid() {
      if (this.refundType !== 'later') {
        return { valid: true };
      }

      // For Australia
      if (this.isAUS) {
        if (!this.reversal.directrefund_account_name && !this.reversal.directrefund_bsb_number && !this.reversal.directrefund_account_number) {
          return { valid: false, error: 'Direct Refund details is required. Please fill in the required fields and try again.' };
        }
        if (this.errors.has('reversal.directrefund_account_name')) {
          return { valid: false, error: this.errors.first('reversal.directrefund_account_name') };
        }
        if (this.errors.has('reversal.directrefund_bsb_number')) {
          return { valid: false, error: this.errors.first('reversal.directrefund_bsb_number') };
        }
        if (this.errors.has('reversal.directrefund_account_number')) {
          return { valid: false, error: this.errors.first('reversal.directrefund_account_number') };
        }
        return { valid: true };
      }

      // For other regions (e.g., NZ)
      if (!this.reversal.directrefund_account_name && !this.reversal.directrefund_account_number) {
          return { valid: false, error: 'Direct Refund details is required. Please fill in the required fields and try again.' };
        }
      if (this.errors.has('reversal.directrefund_account_name')) {
        return { valid: false, error: this.errors.first('reversal.directrefund_account_name') };
      }
      if (this.errors.has('reversal.directrefund_account_number')) {
        return { valid: false, error: this.errors.first('reversal.directrefund_account_number') };
      }
      return { valid: true };
    },

    async setupValidation() {
        await this.isAUSOrNZ();
        this.$validator.extend('customAccountNumberValidation', {
          validate: value => {
            console.log('Validating with:', { isAUS: this.isAUS, isNZ: this.isNZ, value });
            if (this.isAUS) {
              const regex = /^[0-9]{4,9}$/;
              return regex.test(value);
            } else if (this.isNZ) {
              const regex = /^[0-9]{14,16}$/;
              return regex.test(value);
            }
            return false;
          },
          getMessage: field => {
            if (this.isAUS) {
              return `The ${field} must be a valid Australian account number (4-9 digits).`;
            } else if (this.isNZ) {
              return `The ${field} must be a valid New Zealand account number (14-16 digits).`;
            }
            return 'Please contact the onboarding team to get the address updated.';
          }
        });
    },
    updateComponent(){
      this.componentKey += 1;
    },
    async isAUSOrNZ() {
          let r = await api.get(this, api.PROPERTIES + this.property_id);
          this.properties = r.property;
          if(this.properties.Address.country  && /^(AUS|AU|Australia)$/i.test(this.properties.Address.country)) {
            this.isAUS = true;
            this.isNZ = false;
          } else if(this.properties.Address.country && /^(NZ|NZL|New Zealand)$/i.test(this.properties.Address.country)) {
            this.isNZ = true;
            this.isAUS = false;
          } else {
            this.isAUS = false;
            this.isNZ = false;
          }
      },
    async setContactInvoices() {
      let r = await api.get(this, api.CONTACTS +  this.contact_id + '/leases', { property_id: this.property_id, active_date: moment.utc().format('YYYY-MM-DD') });
      this.leases = r.leases.filter(x=> x.id === this.lease_id);
      this.$emit('fetchLeaseData');
    },
    setOpenBalance() {
      this.setContactInvoices();
    },
    setActivitesCounter(value) {
      this.totalActivities = value;
    },
    async fetchOverPayments() {
      var date = moment(this.move_out_date).startOf("day").format("YYYY-MM-DD");
      let r = await api.get(this, api.LEASES + this.lease_id + '/over-payments', {moved_out: date})
      this.account_balance = r.account_balance;
      this.amt_to_refund = r.amt_to_refund;
      this.overpayments = r.overpayments;

      // this.refundInvoices = r.invoices.map(inv => {

      //   inv.credit =  inv.InvoiceLines.reduce((val, line ) => val + line.Credit.total,0) -
      //                 (inv.balance + inv.Payments.filter(x => x.Payment.credit_type !== 'payment').reduce((a,p) =>  a + p.amount, 0));

      //   inv.credit = Math.round(inv.credit * 1e2) / 1e2;

      //   inv.processed = 0;
      //   inv.handle_credit = '';
      //   inv.credit_memo = inv.credit > 0 ? 1: 0;

      //   inv.Payments = inv.Payments.map(p => {
      //       p.credit = 0;
      //       return p;
      //   })
      //   return inv;
      // });
    },
    async calculateMoveOutDate(){
        let date = moment(this.move_out_date).startOf("day").format("YYYY-MM-DD");
        let response = await api.post(this, api.LEASES + this.lease_id + '/calculate-move-out-balance',{moved_out: date});
        // this.moveOutCalc = response;
        this.setMoveOutCalc({moveOutCalc: response})
        if(this.moveOutCalc.total_to_refund > 0){
          this.refundType = await this.getRefundType()
        }
        this.componentKey += 1;
    },
    async getRefundType(){
      //For the US refund will always be immediate.
      if (!this.isNZ && !this.isAUS) {
        console.log("Refunding immediately as it's US.");
        return 'now';
      }
      //For Oceania the refund type will be picked based on a few conditions.
      else {
        let paymentSources = await this.getPaymentSources()

        if (paymentSources.length === 1 && paymentSources[0] === 'Card') {
          console.log("Refunding immediately as it's AUS and Card Payment.");
          return 'now';
        }
        if (paymentSources.length > 1 && paymentSources.every(source => source === 'Card')) {
          console.log("Refunding immediately as it's AUS and Card Payment.");
          return 'now';
        }
        console.log(`Refunding later as it's AUS and Payments are from: `,paymentSources);
        return 'later';
      }
    },
    getPaymentSources() {
      if (!this.moveOutCalc?.paidInvoices) return {};

      return this.moveOutCalc.paidInvoices.reduce((sources, invoice) => {
        if (!invoice.payment_credits) return sources;

        invoice.payment_credits.forEach(credit => {
          const source = credit.Payment.PaymentMethodType.payment_method_type || 'Unknown';
            sources.push(source);
        });
      
        return sources;
      }, []);
    },
    async fetchSecurityDeposit() {
      await api.get(this, api.LEASES + this.lease_id + '/security-deposit').then(r => {
        this.securityDeposit = r.lines.reduce((a,b) => a += b.amount, 0);
      });
    },
    securityRefunded(flag){
      if(flag && this.securityDeposit == 0){
        this.isSecurityRefunded = true;
      }
    },
    getLeaseInfo(){
      var date = moment(this.move_out_date).startOf("day").format("YYYY-MM-DD");
      api.get(this, api.LEASES + this.lease_id + '/metrics', {moved_out: date}).then(r => {
        this.leaseInfo = r.metrics
      })
    },
    refreshContactUnits(){
      if(this.lease.Tenants && this.lease.Tenants.length > 0 && this.lease.Tenants[0].contact_id == this.charmNotification.contact_id){
          this.$store.dispatch('charmNotificationStore/refreshContactUnits',this.charmNotification.contact_id);
      }
      if(this.lease.Tenants && this.lease.Tenants.length > 0 && this.lease.Tenants[0].contact_id == this.notification.contact_id){
          this.$store.dispatch('charmCallStore/refreshContactUnits',this.notification.contact_id);
      }
    },
    async closeLease() {
      console.log("CLOSE -- MOVEOUT", this.move_out_date);
      this.moveOutReasonsErrors.selectedMoveOutReason = '';
      if(!this.selectedMoveOutReason){
        this.showMessageNotification({ type: 'error', description: "Move Out Reason is required" });
        this.moveOutReasonsErrors.selectedMoveOutReason = 'Move Out Reason is required';
        return;
      }
      try {
        this.closeLeaseInProgress = true;
        var moved_out = moment(this.move_out_date).startOf('day').format('YYYY-MM-DD');
        let readyToMove = this.readyToMove;
        var data = {
          moved_out: moved_out,
          availability_date: this.move_in_ready ? moved_out : moment(this.data.availability_date).startOf('day').format('YYYY-MM-DD'),
          readyToMove: readyToMove,
          move_out_reason:this.selectedMoveOutReason
        };

        this.resetContact();

        const response = await api.put(this, api.LEASES + this.lease_id + '/close', data);
        if (readyToMove) {
          await this.moveSpaceBackToInventory();
        }
        this.refreshContactUnits();

        if (response.lease_id) {
          this.leaseClosed = true;
          this.closeLeaseConfirmation = false;
          EventBus.$emit('lease_edited');
          this.$emit('fetchLeaseData');
          EventBus.$emit('contact_updated', this.contact_id);
          EventBus.$emit('contact_updated_transfer');
          EventBus.$emit('reservation_made');
        }
        this.$emit('close');

        await this.resetPropertiesInfo();
        this.fetchPropertyGroups({hardRefresh: true});
      } catch (e) {
        this.showMessageNotification({ type: 'error', description: e });
      } finally {
        this.closeLeaseInProgress = false;
      }
    },

    async getMoveOutData(){
            let payment_method = {}
            let errors;
            console.log('processMoveOut');
            console.log('this.message:', this.moveOutCalc.message);
            this.moveOutReasonsErrors.selectedMoveOutReason = '';
            if(!this.selectedMoveOutReason){
              this.showMessageNotification({ type: 'error', description: "Move Out Reason is required" });
              this.moveOutReasonsErrors.selectedMoveOutReason = 'Move Out Reason is required';
            }
            this.closeLeaseInProgress = true;
            let securityDeposit = this.securityDepositForRefund;
            let moved_out = moment(this.move_out_date).startOf('day').format('YYYY-MM-DD');
            let readyToMove = this.readyToMove;
            let payload = {};
            try {
              this.resetContact();
              this.setPaymentProcessDisabled(true)
              if(this.moveOutCalc.message?.amount_due > 0 && this.paymentOption === 'takePayment'){
                this.setPaymentInformationObject({ paymentInformation: { ...this.payment_information, ...{ amountTendered: Number(this.moveOutCalc.message.amount_due).toFixed(2), totalNewPaymentPaying: Number(this.moveOutCalc.message.amount_due).toFixed(2), totalNewPaymentDue: Number(this.moveOutCalc.message.amount_due).toFixed(2) } } });
                this.setPaymentObject({ payment: { ...this.payment, ...{ amount: Number(this.moveOutCalc.message.amount_due).toFixed(2), contact_id: this.contactId, property_id: this.property_id, amount_tendered: Number(this.payment_information.amountTendered).toFixed(2) } } })
                this.payment.type = 'ivr'
                const paymentInfo = await this.getTransformedPaymentObject({
                      id: this.$options.name,
                      errors: errors,
                      type:'ivr',
                      action : 'ivr_move_out'
                  });
                  if(paymentInfo && paymentInfo.payment){
                      const { payment, paymentMethod, contact_id, property_id } = paymentInfo;
                      payment_method = paymentMethod;
                      this.payment = payment;
                      this.contact_id = contact_id;
                      this.property_id = property_id
                  }
                payload.payment_info = {
                  payment: this.payment,
                  paymentMethod: payment_method,
                  contact_id: this.contact_id,
                  property_id: this.property_id
                }
                payload.lease_id = this.lease_id;
                payload.payment = this.payment;
                payload.paymentMethod = payment_method;
                payload.contact_id = this.contact_id;
                payload.property_id = this.property_id;
                //payload.id = this.$options.name;
                payload.formErrors = this.formErrors;
                payload.type = 'ivr';
              } 

              payload.moved_out = moved_out;
              payload.confirm = true;
              payload.source = 'move_out'
              payload.dueInvoices = this.moveOutCalc.dueInvoices
              payload.additional_charges = this.additionalCharges
              payload.security_deposit_refund = securityDeposit
              payload.availability_date = this.move_in_ready ? moved_out : moment(this.data.availability_date).startOf('day').format('YYYY-MM-DD');
              payload.readyToMove = readyToMove;
              // Set errors as an array for downstream code expecting a list
              payload.errors = [];
              if (this.moveOutReasonsErrors?.selectedMoveOutReason) {
                payload.errors.push(this.moveOutReasonsErrors.selectedMoveOutReason);
              }
              console.log('payload:', payload);
              EventBus.$emit('receive_move_out_data_ivr',{paymentInfo : payload}) 
            }catch (e) {
              this.showMessageNotification({ type: 'error', description: e });
            } finally {
              this.setPaymentProcessDisabled(false)
              this.closeLeaseInProgress = false;
            }
    },

    async processMoveOut(){
      console.log('processMoveOut');
      console.log('this.message:', this.moveOutCalc.message);
      this.moveOutReasonsErrors.selectedMoveOutReason = '';
      if(!this.selectedMoveOutReason){
        this.showMessageNotification({ type: 'error', description: "Move Out Reason is required" });
        this.moveOutReasonsErrors.selectedMoveOutReason = 'Move Out Reason is required';
        return;
      }

      // Validate payment method if taking payment
      let payment_method = {};
      if(this.moveOutCalc.message?.amount_due > 0 && this.paymentOption === 'takePayment'){
        try {
            payment_method = await this.$refs.paymentView.validatePayment();
            if(payment_method === false){
              return;
            }
            if(payment_method === undefined){
              throw Error('Payment method is not selected.');
            }
        } catch (e) {
          this.showMessageNotification({ type: 'error', title: 'Unable to process payment',  description: 'Please select a payment method to continue' });
          return;
        }
      }

      // Validate direct refund details if refunding later
      if (this.moveOutCalc.message?.refund_amount > 0 && this.refundType == 'later') {
        try{
          let result = await this.isDirectRefundValid();
          console.log('Direct Refund Valid:', result);
          if (!result.valid) {
            this.showMessageNotification({ type: 'error', description: result.error });
            return;
          }
          if (result === undefined){
          throw Error('Direct refund details is required.');
          }
        }catch (e) {
          console.log('Error validating direct refund:', e);
           this.showMessageNotification({ type: 'error', description: 'Direct Refund details is required. Please fill in the required fields and try again.' });
          return;
        }
      }

      // All validations passed, now show confirmation modal
      let confirm = await this.getConfirmation();
      if (confirm === false) {
        return;
      }
      this.closeLeaseInProgress = true;
      let securityDeposit = this.securityDepositForRefund;
      let moved_out = moment(this.move_out_date).startOf('day').format('YYYY-MM-DD');
      let readyToMove = this.readyToMove;
      let payload = {};
      try {
        this.resetContact();
        this.setPaymentProcessDisabled(true)
        if(this.moveOutCalc.message?.amount_due > 0 && this.paymentOption === 'takePayment'){
          this.setPaymentInformationObject({ paymentInformation: { ...this.payment_information, ...{ amountTendered: Number(this.moveOutCalc.message.amount_due).toFixed(2), totalNewPaymentPaying: Number(this.moveOutCalc.message.amount_due).toFixed(2) } } });
          this.setPaymentObject({ payment: { ...this.payment, ...{ amount: Number(this.moveOutCalc.message.amount_due).toFixed(2), contact_id: this.contactId, property_id: this.property_id, amount_tendered: Number(this.payment_information.amountTendered).toFixed(2) } } })
          payload.payment_info = {
            payment: this.payment,
            paymentMethod: payment_method,
            contact_id: this.contact_id,
            property_id: this.property_id
          };
        } else if (this.moveOutCalc.message?.refund_amount > 0 && this.refundType == 'later') {
          payload.future_refund = true;
          payload.directRefund = {
            type: 'directrefund',
            directrefund_bsb_number: this.reversal?.directrefund_bsb_number || '',
            directrefund_account_number: this.reversal?.directrefund_account_number,
            directrefund_account_name: this.reversal?.directrefund_account_name,
          };
        }

        if (this.paymentOption === 'skipPayment') {
          payload.skip_payment = true;
        }
        if(this.write_off === true){
          payload.write_off = true;
          payload.writeOffReason = this.writeOffReason;
        }
        if (this.skipRefund) {
          payload.skipRefund = true;
        }
        payload.moved_out = moved_out;
        payload.confirm = true;
        payload.source = 'move_out'
        payload.dueInvoices = this.moveOutCalc.dueInvoices
        payload.additional_charges = this.additionalCharges
        payload.security_deposit_refund = securityDeposit
        payload.availability_date = this.move_in_ready ? moved_out : moment(this.data.availability_date).startOf('day').format('YYYY-MM-DD');
        payload.readyToMove = readyToMove;
        payload.move_out_reason = this.selectedMoveOutReason;

        console.log('payload:', payload);

        let response = await api.post(this, api.LEASES + this.lease_id + '/calculate-move-out-balance', payload);
        console.log('response:', response);
         this.setPaymentProcessDisabled(false)
        if (readyToMove) {
          await this.moveSpaceBackToInventory();
          if(response){
            this.leaseClosed = true;
            this.closeLeaseConfirmation = false;
            EventBus.$emit('lease_edited');
            this.$emit('fetchLeaseData');
            EventBus.$emit('contact_updated', this.contact_id);
            EventBus.$emit('contact_updated_transfer');
            EventBus.$emit('reservation_made');
          }
        }
        this.refreshContactUnits();
        this.$emit('close');

        await this.resetPropertiesInfo();
        await this.fetchPropertyGroups({hardRefresh: true});
      } catch (e) {
        this.showMessageNotification({ type: 'error', description: e });
      } finally {
        this.setPaymentProcessDisabled(false)
        this.closeLeaseInProgress = false;
      }
    },

    async getConfirmation(){
      return new Promise((resolve) => {
        this.confirmationModal = true;
        this.confirmationResolve = resolve;
      });
    },
    
    confirmMoveOut() {
      // Validate write-off reason if payment option is write-off
      if (this.paymentOption === 'writeOff') {
        if (!this.writeOffReason || this.writeOffReason.trim() === '') {
          this.showMessageNotification({ 
            type: 'error', 
            description: 'Write Off Reason is required. Please fill in the required fields and try again.' 
          });
          return;
        }
        
        if (this.writeOffReason.length > 1000) {
          this.showMessageNotification({ 
            type: 'error', 
            description: 'Write Off Reason cannot exceed 1000 characters.' 
          });
          return;
        }
        this.write_off = true;
      }

      // Resolve the promise with true to proceed with move-out
      if (this.confirmationResolve) {
        this.confirmationResolve(true);
        this.confirmationResolve = null;
      }
      this.confirmationModal = false;
    },
    
    cancelConfirmation() {
      // Resolve the promise with false to cancel move-out
      if (this.confirmationResolve) {
        this.confirmationResolve(false);
        this.confirmationResolve = null;
      }
      this.confirmationModal = false;
    },
    async moveSpaceBackToInventory() {
      this.finalizeInProgress = true;
      try {
        await api.put(this, api.UNITS + this.unit_id + '/enable');
        this.$emit('fetchLeaseData');
      } catch (err) {
        this.showMessageNotification({ type: 'error', description: err });
      } finally {
        this.finalizeInProgress = false;
      }
    },
    getFees(){
        api.get(this, api.PROPERTIES  + this.property_id + '/products?type=late&category_type=moveout' ).then(r => {
            this.products = r.products;
        });
    },
    async getMoveOutReasons(){
     let reasons =  await api.get(this, api.MOVE_OUT_REASONS);
     this.move_out_reasons = reasons.map(r => r.reason);
    },
    closeNotesModal(payload){
      this.showNoteModal = payload;
    },
  },
  beforeDestroy(){
    this.$store.commit("paymentsStore/resetMoveOutCalc");
    this.$store.commit("paymentsStore/resetAdditionalCharges");
    this.$store.commit("paymentsStore/resetSecurityDeposit");
    this.moveOutReasonsErrors.selectedMoveOutReason = '';
  }
};
</script>

<style scoped lang="scss">
.intent-section {
  padding: 20px 50px 75px 50px;
}

.intent-section .new-tenant-walkthrough-footer {
  padding: 3px 0 3px 30px;
  background: #ffffff;
  border-top: 1px solid #e2e2e2;
  position: absolute;
  bottom: 0;
  width: 100%;
  z-index: 100;
  left: 0;
  right: 0;
}
.light-text {
  color: rgba(0, 0, 0, 0.6);
}
.panel-header-custom-setting {
  background-color: rgb(251, 228, 224);
  color: rgba(0, 0, 0, 1);
}
.move-out-btn {
  border-radius: 4px;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(0, 132, 142, 0.05) 100%
  );
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);

  p {
    color: rgb(0, 132, 142);
    font-size: 15px;
    font-weight: 500;
    padding-top: 5px;
    padding-bottom: 5px;
  }
}
.relative-box {
  position: relative;

  span.counter-absolute {
    position: absolute;
    right: -20px;
    background: #f26500;
    color: #fff;
    font-weight: 500;
    padding: 5px 11px;
    border-radius: 50%;
    border: 5px solid #fff;
    top: -10px;
    z-index: 1;
  }
}
.move-up-text {
  position: relative;
  top: -4px;
}
.font-16px {
  font-size: 16px;
  font-weight: 500;
}
.font-15px {
  font-size: 15px;
  font-weight: 500;
}
.no-focus-border-btn {
  border: 0;
}

/* Refund visual feedback styles */
.refund-disabled {
  position: relative;
}

.refund-status-banner {
  border-left: 4px solid;
}

.opacity-60 {
  opacity: 0.6;
}

/* Refund toggle layout styles */
.refund-checkbox-container {
  width: 100%;
}

.refund-checkbox-container .v-input--switch {
  margin: 0;
  padding: 0;
}

.refund-checkbox-container .v-input--switch .v-input__control {
  min-height: auto;
}

.refund-checkbox-container .v-input--switch .v-input__slot {
  margin-bottom: 0;
}
</style>

<style>
.move-out-expan-panels.theme--light.v-expansion-panels
  .v-expansion-panel:not(:first-child)::after {
  border-color: rgba(0, 0, 0, 0) !important;
}
.move-out-expan-panels.theme--light.v-expansion-panels
  .v-expansion-panel--active
  + .v-expansion-panel {
  margin-top: 5px;
}
.no-padding-panel > .v-expansion-panel-content__wrap {
  padding: unset !important;
}
</style>
